import React, { useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import {
  Box,
  Divider,
} from '@mui/material';
import OpacityIcon from "@mui/icons-material/Opacity";

import { authTokenState, cognitoIdState } from 'features/auth/state/authAtoms';
import { apiRenderKeyState } from 'shared/state/renderKeyAtoms';
import { yamlConfigState } from 'features/optimization/state/yamlConfigAtoms';
import { CustomTypography } from 'shared/ui/CustomTypography';
import { CustomButton } from 'shared/ui/CustomButton';
import { submitWaterTightCheck } from 'features/cfd/api/submitWaterTightCheck';
import { canStartGeometryCheck } from 'features/cfd/utils/yamlValidation';

const subtitleSx = {
  display: 'flex',
  alignItems: 'center',
};

export const GeometryCheck: React.FC = () => {
  const setRenderKey = useSetRecoilState(apiRenderKeyState);

  const authToken = useRecoilValue(authTokenState);
  const cognitoId = useRecoilValue(cognitoIdState);
  const yamlConfig = useRecoilValue(yamlConfigState);

  const [apiLoading, setApiLoading] = useState<boolean>(false);

  const startClick = async () => {
    // ジオメトリチェックの前提条件を満たした場合のみ実行する
    if (canStartGeometryCheck(yamlConfig)) {
      setApiLoading(true);
      await submitWaterTightCheck(
        yamlConfig,
        authToken,
        cognitoId,
      );
      setRenderKey((p) => p + 1);
      setApiLoading(false);
    }
  };

  return (
    <Box component="div" sx={{ boxSizing: 'border-box', flexGrow: 1 }}>
      <Box component="div" sx={subtitleSx}>
        <CustomTypography>Geometry Check</CustomTypography>
      </Box>

      <Divider sx={{ width: '100%', my: 0.5, bgcolor: '#e1e1e1' }} />

      <Box component="div" sx={{ display: 'flex', gap: 0.5 }}>
        <CustomButton
          size='small'
          disabled={apiLoading}
          onClick={startClick}
          loading={apiLoading}
          loadingPosition='start'
          startIcon={<OpacityIcon />}
          variant='contained'
          sx={{ fontSize: '10px', width: '100%' }}
        >
          Water Tight Check
        </CustomButton>
      </Box >
    </Box >
  );
};
